const callbacks = new Map();
let observer = null;

function getObserver() {
  if (observer) return observer;
  if (typeof IntersectionObserver !== "function") return null;
  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        callbacks.get(entry.target)?.(entry.isIntersecting);
      });
    },
    { root: null, rootMargin: "120px 0px", threshold: 0 },
  );
  return observer;
}

export function observeFoilVisibility(node, onChange) {
  const obs = node ? getObserver() : null;
  if (!obs) {
    onChange(true);
    return () => {};
  }
  callbacks.set(node, onChange);
  obs.observe(node);
  return () => {
    callbacks.delete(node);
    obs.unobserve(node);
  };
}
